/**
 *
 * File LoginRequest.js
 *
 */
(function () {
    angular
        .module('maApp.remoteRequests')
        .factory('LoginRequest', LoginRequest);

    LoginRequest.$inject = ['$http', '$httpParamSerializer', '$interpolate', 'RequestError'];

    function LoginRequest($http, $httpParamSerializer, $interpolate, RequestError) {

        var BASEURL = '//' + DEFAULT_HOST  + '/apps/authentication/inc/php/';
        var CONTENTTYPE_FORM_HEADER = {'Content-Type': 'application/x-www-form-urlencoded'};

        return {
            'postUsername':fetchAccountType,
            'simpleSignin':authenticationSimpleSigninAccount,
            'hortonSigninToken':fetchHortonSigninToken,
            'hortonSignin':authenticatePointBlueAccount
        };

        function headers(){
            return angular.copy(CONTENTTYPE_FORM_HEADER);
        }

        function fetchAccountType(userid) {
            return $http({
                method: 'POST',
                url: $interpolate('{{base}}process_login_nocookies.php')({'base':BASEURL}),
                data: $httpParamSerializer({'userid':userid}),
                'headers':headers()
            })
                .then(postSuccess, postFail);

            function postSuccess(response){
                return response.data;
            }

            function postFail(response){
                throw new RequestError(response, 'Failed to fetch the type of user account');
            }
        }

        function authenticationSimpleSigninAccount(userid, password) {
            return $http({
                method: 'POST',
                url: $interpolate('{{base}}process_login_nocookies.php')({'base':BASEURL}),
                data: $httpParamSerializer({'userid':userid, 'password':password}),
                'headers': headers()
            })
                .then(postSuccess, postFail);

            function postSuccess(response){
                return response.data;
            }

            function postFail(response){
                throw new RequestError(response, 'Failed to authenticate Simple Signon account');
            }
        }

        /**
         * fetchHortonSigninToken
         *
         * Fetches parameters needed to sign in from the Horton server
         *
         * @param userid
         * @returns {*}
         */
        function fetchHortonSigninToken(userid) {
            return $http({
                url:$interpolate('{{base}}sso/requestLoginURL.php')({'base':BASEURL}),
                params:{
                    'userid':userid
                }
            })
                .then(getSuccess, getFail);

            function getSuccess(response){
                return urlParametersAsObject(response.data.url);
            }

            function getFail(response){
                throw new RequestError(response, 'Failed to fetch Horton server login parameters');
            }
        }

        function authenticatePointBlueAccount(password, q, userid) {
            return $http({
                method: 'POST',
                url: 'https://horton.prbo.org/loginFrame_json.php',
                data: $httpParamSerializer({'pwd':password, 'q':q, 'userid':userid}),
                headers: headers()
            })
                .then(postSuccess, postFail);

            function postSuccess(response){
                return response.data;
            }

            function postFail(response){
                throw new RequestError(response, 'Failed to authenticate Point Blue account');
            }

        }

        function urlParametersAsObject(url){
            var parser = document.createElement('a');
            parser.href = url;
            var params = {};
            var keyAndValueSets = parser.search.substring(1).split('&');
            var keyAndValue;
            for(var i=0;i<keyAndValueSets.length;i++){
                keyAndValue = keyAndValueSets[i].split('=');
                params[keyAndValue[0]] = decodeURIComponent(keyAndValue[1]);
            }

            return params;
        }

    }
})();